import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, CalculatorIcon, DollarSignIcon, PercentIcon, TrendingDownIcon } from 'lucide-react';
import { problems } from '../data/content';
const icons = {
  DollarSign: DollarSignIcon,
  Calculator: CalculatorIcon,
  Percent: PercentIcon,
  TrendingDown: TrendingDownIcon,
  BarChart3: BarChart3Icon
};
export function Problems() {
  return <section className="w-full bg-sage-mist py-16 sm:py-24" aria-labelledby="problemas-title" style={{
    paddingTop: "6px",
    paddingBottom: "6px"
  }} data-id="element-121" data-mp="2t4vzm1zp74xl">
      <div className="mx-auto max-w-6xl px-5" data-id="element-122" data-mp="2o3yhtqilocwm">
        <div className="mx-auto max-w-2xl text-center" data-id="element-123" data-mp="2j5n8dgw7w4ex">
          
          <h2 id="problemas-title" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-black sm:text-4xl" data-id="element-124" data-mp="2j89hvm2o4tzs">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <p className="mt-4 text-base leading-relaxed text-forest-deep/75" data-id="element-125" data-mp="hcple1p4g61w">
            Vendés todos los días y trabajás muchísimo, pero nunca sabés si
            realmente estás ganando plata.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-126" data-mp="39py3frk8s8ll">
          {problems.map((problem, index) => {
          const Icon = icons[problem.icon];
          return <motion.li key={problem.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.06
          }} className="rounded-2xl border border-sage/70 bg-white p-6 shadow-card" data-id="element-127" data-mp="2vrzrstxb2q9s" data-mpi={index}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-forest" data-id="element-128" data-mp="3eoj4tub8cybm">
                  <Icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-129" data-mp="3iotf3j622awa" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold leading-snug text-black" data-id="element-130" data-mp="a9jg4jxgplsq">
                  {problem.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-forest-deep/75" data-id="element-131" data-mp="oy1jjtay053f">
                  {problem.description}
                </p>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}